var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.02987 8.48116e-08C5.76225 1.08208e-07 5.53644 0.0920507 5.35245 0.276151L0.342891 5.23849C0.108721 5.46444 -5.50142e-07 5.70711 -5.24537e-07 6C-4.98932e-07 6.29289 0.108721 6.54393 0.334528 6.76151L5.35245 11.7238C5.53644 11.9079 5.76225 12 6.02987 12C6.56511 12 7 11.5732 7 11.0377C7 10.7699 6.89128 10.5272 6.69892 10.3264L2.29988 5.99163L6.69892 1.66527C6.89128 1.4728 7 1.23013 7 0.962343C7 0.426778 6.56511 3.8019e-08 6.02987 8.48116e-08Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrow-icon.f8a4b61414681fd4d4806b1a2605f869.svg";
export { ForwardRef as ReactComponent };